<template>
  <!-- <div id="vue-container" tyle="height:160px; width:400px; background:green"> -->
  <div class="users-chart-container">
    <v-chart
      :options="option"
      :autoresize="true"
      id="user-line-chart"
    ></v-chart>
  </div>
  <!-- </div> -->
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import { mapGetters } from "vuex";
export default {
  name: "sdcs",

  data() {
    return {
      maxGraph: 0,
      minGraph: 0,
      option: {}
    };
  },
  components: {
    "v-chart": ECharts
  },
  computed: {
    ...mapGetters(["getSkillgamesSingleUsage", "getSkillgamesMultiUsage"])
  },
  methods: {
    makeListNegative(array) {
      return array.map(x => x * -1);
    },
    drawGraph() {
      this.option = {
        title: {
          text: "Main Title",
          subtext: "Sub Title",
          left: "center",
          top: "center",

          textAlign: "center",
          show: true
        },

        backgroundColor: "#383838",
        color: ["#5696fc", "#7faffc", "#b9d4ff", "#eaf2ff"],
        calculable: true,
        grid: {
          show: false,
          left: "3%",
          right: "3%",
          top: "3%",
          bottom: "3%",
          width: "95%",
          height: "95%",
          containLabel: true
        },
        xAxis: {
          name: "Multiplayer",
          nameLocation: "start",
          nameTextStyle: {
            fontSize: 14,
            align: "left",
            verticalAlign: "top",
            lineHeight: +90,
            padding: [0, 0, 0, 20],
            color: "#fff"
          },
          show: true,
          type: "category",

          data: ["00", "03", "06", "09", "12", "15", "18", "21", "23"],

          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#aaa",
              type: "dashed",
              width: 1,
              shadowBlur: 3
            }
          },

          axisLabel: {
            show: true,
            interval: 0,
            color: "#aaaaaa",
            margin: 12
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: "#aaa",
              type: "dashed",
              width: 1,
              shadowBlur: 3
            }
          }
        },
        yAxis: {
          name: "Singleplayer",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 14,
            align: "left",
            verticalAlign: "top",
            lineHeight: 30,
            padding: [20, 0, 0, 10],
            color: "#fff"
          },
          show: true,
          type: "value",
          position: "left",
          offset: 6,
          boundaryGap: true,
          /////////////////////////////////////////////////////////////////////////////
          min: this.minGraph,
          max: this.maxGraph,
          splitNumber: 0,
          splitLine: {
            show: false,
            lineStyle: {
              color: "#aaa",
              type: "dashed",
              width: 1,
              shadowBlur: 3
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            margin: 0,
            color: "#aaa"
          },

          minInterval: 1, //to make sure axis label is show as integer.
          maxInterval: 3600 * 1000 * 24 //gap between axis labels is less than or equal to one day.
        },

        series: [
          {
            name: "AA",
            type: "line",
            silent: true,
            smooth: true,
            lineStyle: {
              color: "#eae83a",
              Width: "3px"
            },
            areaStyle: {
              opacity: "0.20",
              color: new ECharts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "#383838" },
                { offset: 1, color: "#eae83a" }
              ])
            },

            itemStyle: {
              color: "#29b377",
              opacity: "0"
            },
            // data: [10, 30, 70, 70, 30, 80, 70, 20, 20],
            data: this.getSkillgamesSingleUsage[0]
          },
          {
            name: "BB",
            type: "line",
            smooth: true,

            lineStyle: {
              color: "#29b377",
              Width: "3px"
            },

            areaStyle: {
              opacity: "0.20",
              color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#383838" },
                { offset: 1, color: "#29b377" }
              ])
            },

            itemStyle: {
              color: "#29b377",
              opacity: "0"
            },
            // data: [-100, -1, -2, -8, -80, -1, -3, -1, -1],
            data: this.makeListNegative(this.getSkillgamesMultiUsage[0])
          }
        ]
      };
    }
  },

  watch: {
    getSkillgamesMultiUsage() {
      let maxSinglePlayer = 0;
      let maxMultiPlayer = 0;

      maxSinglePlayer = Math.max.apply(null, this.getSkillgamesSingleUsage[0]);

      maxMultiPlayer = Math.max.apply(null, this.getSkillgamesMultiUsage[0]);

      if (maxSinglePlayer > maxMultiPlayer) {
        this.maxGraph = maxSinglePlayer + 10;
        this.minGraph = this.maxGraph * -1;
      } else {
        this.maxGraph = maxMultiPlayer + 10;
        this.minGraph = this.maxGraph * -1;
      }

      this.drawGraph();
    }
  }
};
</script>

<style>
#vue-container {
  width: 400px;
}

#user-line-chart {
  height: 248px;
  width: inherit;
}

.users-chart-container {
  border: red;
}
</style>
